export default {
  documents: [],
  newDocuments: [],
  processedDocuments: [],
  document: undefined,
  allDocuments: [],
};
